var _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _polygon3, _polygon4, _rect5, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPA0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.0.1",
    x: 290,
    y: 378,
    width: 86,
    height: 123
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.0.2",
    x: 143.93,
    y: 378,
    width: 142.07,
    height: 123
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.0.3",
    x: 133,
    y: 189,
    width: 126,
    height: 185
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.0.4",
    x: 262.91,
    y: 189,
    width: 113.09,
    height: 151.16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.5",
    points: "381 206 494 206 494 330.05 469 330.05 469 340 381 340 381 206"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.6",
    points: "498.75 206 611 206 611 340 523 340 523 330 498.75 330 498.75 206"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.7",
    points: "616.06 206 729 206 729 330 705 330 705 340 616.06 340 616.06 206"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.8",
    points: "734 217 906 217 906 374 828 374 828 340 734 340 734 217"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "A.0.9",
    x: 734,
    y: 378.83,
    width: 183,
    height: 151.17
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.10",
    points: "641.1 378.83 729 378.83 729 530 616.39 530 616.39 389 641 389 641.1 378.83"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "A.0.11",
    points: "544.98 378.83 587 378.83 587 389 611 389 611 513 538 513 538 456 545 456 544.98 378.83"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgCiAgICB2aWV3Qm94PSIwIDAgOTkwIDcyMCIKPgogIDxyZWN0IGRhdGEtaWQ9IkEuMC4xIiB4PSIyOTAiIHk9IjM3OCIgd2lkdGg9Ijg2IiBoZWlnaHQ9IjEyMyIgLz4KICA8cmVjdCBkYXRhLWlkPSJBLjAuMiIgeD0iMTQzLjkzIiB5PSIzNzgiIHdpZHRoPSIxNDIuMDciIGhlaWdodD0iMTIzIiAvPgogIDxyZWN0IGRhdGEtaWQ9IkEuMC4zIiB4PSIxMzMiIHk9IjE4OSIgd2lkdGg9IjEyNiIgaGVpZ2h0PSIxODUiIC8+CiAgPHJlY3QgZGF0YS1pZD0iQS4wLjQiIHg9IjI2Mi45MSIgeT0iMTg5IiB3aWR0aD0iMTEzLjA5IiBoZWlnaHQ9IjE1MS4xNiIgLz4KICA8cG9seWdvbiBkYXRhLWlkPSJBLjAuNSIgcG9pbnRzPSIzODEgMjA2IDQ5NCAyMDYgNDk0IDMzMC4wNSA0NjkgMzMwLjA1IDQ2OSAzNDAgMzgxIDM0MCAzODEgMjA2IiAvPgogIDxwb2x5Z29uIGRhdGEtaWQ9IkEuMC42IiBwb2ludHM9IjQ5OC43NSAyMDYgNjExIDIwNiA2MTEgMzQwIDUyMyAzNDAgNTIzIDMzMCA0OTguNzUgMzMwIDQ5OC43NSAyMDYiIC8+CiAgPHBvbHlnb24gZGF0YS1pZD0iQS4wLjciIHBvaW50cz0iNjE2LjA2IDIwNiA3MjkgMjA2IDcyOSAzMzAgNzA1IDMzMCA3MDUgMzQwIDYxNi4wNiAzNDAgNjE2LjA2IDIwNiIgLz4KICA8cG9seWdvbiBkYXRhLWlkPSJBLjAuOCIgcG9pbnRzPSI3MzQgMjE3IDkwNiAyMTcgOTA2IDM3NCA4MjggMzc0IDgyOCAzNDAgNzM0IDM0MCA3MzQgMjE3IiAvPgogIDxyZWN0IGRhdGEtaWQ9IkEuMC45IiB4PSI3MzQiIHk9IjM3OC44MyIgd2lkdGg9IjE4MyIgaGVpZ2h0PSIxNTEuMTciIC8+CiAgPHBvbHlnb24gZGF0YS1pZD0iQS4wLjEwIiBwb2ludHM9IjY0MS4xIDM3OC44MyA3MjkgMzc4LjgzIDcyOSA1MzAgNjE2LjM5IDUzMCA2MTYuMzkgMzg5IDY0MSAzODkgNjQxLjEgMzc4LjgzIiAvPgogIDxwb2x5Z29uIGRhdGEtaWQ9IkEuMC4xMSIgcG9pbnRzPSI1NDQuOTggMzc4LjgzIDU4NyAzNzguODMgNTg3IDM4OSA2MTEgMzg5IDYxMSA1MTMgNTM4IDUxMyA1MzggNDU2IDU0NSA0NTYgNTQ0Ljk4IDM3OC44MyIgLz4KPC9zdmc+";
export { SvgPA0 as ReactComponent };